import { searchFilters, searchSorts } from "/app/src/routes/{-$locale}/profile/$id/index.tsx?tsr-shared=1";
const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/profile/$id/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const profileTabs = ["showcase", "library", "activity"] as const;
type ProfileTab = (typeof profileTabs)[number];
type SearchFilter = (typeof searchFilters)[number];
type SearchSort = (typeof searchSorts)[number];
const profileParamsSchema = z.object({
  tab: z.enum(profileTabs).optional().catch(undefined),
  page: z.coerce.number().int().min(1).optional().catch(undefined),
  activityPage: z.coerce.number().int().min(1).optional().catch(undefined),
  filter: z.enum(searchFilters).optional().catch(undefined),
  sort: z.enum(searchSorts).optional().catch(undefined),
  platinum: z.preprocess(value => {
    if (value === "true") return true;
    if (value === "false") return false;
    return value;
  }, z.boolean().optional()).optional()
});
type ProfileSearch = {
  tab?: ProfileTab;
  page?: number;
  activityPage?: number;
  filter?: SearchFilter;
  sort?: SearchSort;
};
type EffectiveProfileSearch = {
  tab: ProfileTab;
  page: number;
  activityPage: number;
  filter: SearchFilter;
  sort: SearchSort;
};
export const Route = createFileRoute("/{-$locale}/profile/$id/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: (search): ProfileSearch => {
    const parsed = profileParamsSchema.parse(search);
    const normalized: ProfileSearch = {};
    if (parsed.tab) normalized.tab = parsed.tab;
    if (parsed.page) normalized.page = parsed.page;
    if (parsed.activityPage) normalized.activityPage = parsed.activityPage;
    if (parsed.platinum) {
      normalized.filter = "platinum";
    } else if (parsed.filter) {
      normalized.filter = parsed.filter;
    }
    if (parsed.sort) normalized.sort = parsed.sort;
    return normalized;
  }
});